import { Typography, Button, Fade } from '@mui/material';
import Grid from 'components/core/Grid';
import LoadingSkeleton from 'components/core/LoadingSkeleton/LoadingSkeleton';
import styled, { css } from 'styled-components';
import WarningIcon from '@mui/icons-material/Warning';

const StyledBookingSettingsItem = styled(Grid) <{ $isHighlighted: boolean }>`  
  &:not(:first-child) {
    margin-top: ${props => props.theme.spacing(2)};
  }

  ${props =>
    props.$isHighlighted &&
    css`
    border: 1px solid ${props => props.theme.palette.secondary.main};
    border-radius: 5px;
    background-color: ${props => props.theme.layout.lightBackground};
  `}
  
`;

const TitleTypography = styled(Typography)`
  display: flex;
  align-items: center;
  font-size: 1.25rem !important;

  & svg {
    font-size: 1.25rem;
    margin-right: ${props => props.theme.spacing(1)};
    color: ${props => props.theme.palette.warning.main};
    margin-bottom: 2px;
  }
`;

const StyledButton = styled(Button)`
  min-width: 0px !important;
`;

interface BookingSettingsItemProps {
  title: string;
  value: string | undefined;
  onClick: () => void;
  disabled?: boolean;
  buttonText?: string;
  isLoading?: boolean;
  isHighlighted?: boolean;
  hasWarning?: boolean;
  buttonProps?: {
    disabled?: boolean;
  };
}

export const BookingSettingsItem = ({
  title,
  value,
  onClick,
  disabled = false,
  buttonText = 'Edit',
  isLoading = false,
  isHighlighted = false,
  hasWarning = false,
  buttonProps,
}: BookingSettingsItemProps) => {
  const loading = isLoading || !value;
  const isDisabled = disabled || loading || buttonProps?.disabled;

  return (
    <Fade in>
      <div>
        <Grid container spacing={2}>
          <StyledBookingSettingsItem item xs={12} $isHighlighted={isHighlighted}>
            <Grid container alignItems="center">
              <Grid item xs={hasWarning ? 12 : 10} sm={10}>
                <LoadingSkeleton isLoading={loading} width={'95%'}>
                  <TitleTypography fontWeight="500">
                    {hasWarning && <WarningIcon />} {title}
                  </TitleTypography>
                </LoadingSkeleton>
                <LoadingSkeleton isLoading={loading} width={'95%'}>
                  <Typography variant="body1">{loading ? 'placeholder' : value}</Typography>
                </LoadingSkeleton>
              </Grid>
              <Grid item xs={hasWarning ? 12 : 2} sm={2} mt={hasWarning ? 2 : null}>
                <StyledButton variant="contained" fullWidth onClick={onClick} disabled={isDisabled} color="secondary">
                  {buttonText}
                </StyledButton>
              </Grid>
            </Grid>
          </StyledBookingSettingsItem>
        </Grid>
      </div>
    </Fade>
  );
};
